// =============================================================================
// SHARE PETITION SCREEN - Екран створення посилання на петицію (Tactical Design)
// =============================================================================

import { BaseCampaignForm } from './BaseCampaignForm';

interface SharePetitionScreenProps {
    onBack: () => void;
}

export function SharePetitionScreen({ onBack }: Readonly<SharePetitionScreenProps>) {
  return (
    <BaseCampaignForm
      onBack={onBack}
      campaignType="petition"
      ariaLabel="Створення петиції"
      headerTitle="Поширити петицію"
      headerSubtitle="Згенеруйте посилання на гру з інтегрованою петицією"
      terminalLabel="МОДУЛЬ ІНТЕГРАЦІЇ ПЕТИЦІЇ"
      urlLabel="Посилання на петицію"
      urlPlaceholder="https://petition.president.gov.ua/petition/123456"
      urlMissingError="Введіть посилання на петицію"
      urlInvalidError="Невірний формат посилання"
      urlDomainError="Підтримуються тільки посилання на petition.president.gov.ua"
      urlDomainCheck={(url) => url.includes('petition.president.gov.ua')}
      titleLabel="Назва петиції (необов'язково)"
      titlePlaceholder="Петиція про..."
      defaultTitle="ПІДПИШИ ПЕТИЦІЮ"
      descriptionLabel="Опис (необов'язково)"
      descriptionPlaceholder="Короткий опис, що ви хочете донести..."
      footerText="Гравцю буде запропоновано підписати петицію в процесі гри"
    />
  );
}